import React from 'react';
import { FadeIn, Section } from './Section';
import { motion } from 'framer-motion';
export function Hero() {
  return <Section bg="cream" className="min-h-screen flex flex-col justify-start md:justify-center relative overflow-hidden pt-12 pb-16 md:pt-24 md:pb-24" data-id="element-157">
      {/* Decorative background — extremely subtle */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-158">
        <div className="absolute top-[5%] right-[-15%] w-[400px] md:w-[700px] h-[400px] md:h-[700px] rounded-full bg-blush opacity-30 blur-3xl" data-id="element-159" />
        <div className="absolute bottom-[-20%] left-[-15%] w-[500px] md:w-[800px] h-[500px] md:h-[800px] rounded-full bg-cream-dark opacity-40 blur-3xl" data-id="element-160" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center w-full" data-id="element-161">
        {/* H1 — refined serif, breathing room */}
        <FadeIn delay={0.05} data-id="element-162">
          <h1 className="font-serif font-normal text-plum mb-8 md:mb-12 sm:text-3xl md:text-5xl lg:text-6xl max-w-4xl mx-auto tracking-tight text-[32px]" data-id="element-163">
            El pack que necesitás para pasar de tener una habilidad a{' '}
            <span className="italic text-gold font-medium" data-id="element-164">vivir de ella</span>
            <span className="block mt-1 md:mt-2 text-plum/90" data-id="element-165">
              {' '}
              — en menos de 30 días.
            </span>
          </h1>
        </FadeIn>

        {/* Dominant mockup — 80-85% width, the visual hero */}
        <FadeIn delay={0.15} data-id="element-166">
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 1.2,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="mx-auto w-[92%] md:w-[72%] lg:w-[62%] max-w-[680px] mb-4 md:mb-6" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/8ZnpkNKxJUt8GNoSv4qA3k/mokup_nuevo.jpg" alt="Mujer Expansiva — Pack completo: ebook + workbooks + tracker" width="680" height="680" loading="eager" decoding="async" fetchpriority="high" className="w-full h-auto rounded-lg" style={{
            filter: 'drop-shadow(0 30px 60px rgba(107, 30, 46, 0.18))'
          }} data-id="element-168" />
          </motion.div>
        </FadeIn>

        {/* Tiny structural caption */}
        <FadeIn delay={0.25} data-id="element-169">
          <p className="md:text-xs text-plum/45 italic font-serif mb-8 md:mb-10 max-w-2xl mx-auto px-4 tracking-wide text-[14px]" data-id="element-170">
            Pack de mentalidad y acompañamiento realista. 4 tomos + 4 bonos +
            serie premium con acompañamiento 1:1 para ayudarte con esta ruta
            hacia la abundancia.
          </p>
        </FadeIn>

        {/* Subtitle */}
        <FadeIn delay={0.3} data-id="element-171">
          <p className="text-base md:text-lg text-plum/75 mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed font-light px-2" data-id="element-172">
            Aprende a monetizar lo que ya sabés hacer, cobra lo que realmente
            valés y desarrollá la mentalidad próspera que nadie te enseñó. Sin
            más años perdidos. Sin seguir esperando estar lista.
          </p>
        </FadeIn>

        {/* Single champagne CTA */}
        <FadeIn delay={0.4} data-id="element-173">
          <motion.a href="#pricing" whileHover={{
          scale: 1.02,
          y: -2
        }} whileTap={{
          scale: 0.98
        }} transition={{
          duration: 0.25
        }} className="inline-block bg-gold hover:bg-gold-light text-white px-10 py-4 md:px-14 md:py-5 text-xs md:text-sm font-medium tracking-[0.25em] uppercase shadow-xl shadow-gold/20 transition-colors duration-300" data-id="element-174">
            💥Quiero mi acceso!
          </motion.a>

          <p className="mt-6 md:mt-8 text-[10px] md:text-xs uppercase tracking-[0.2em] text-plum/40 font-medium" data-id="element-175">
            Garantía 7 días♻️ · Acceso inmediato✅ · +600 Mujeres⚜️
          </p>
        </FadeIn>
      </div>
    </Section>;
}